module.exports = __webpack_public_path__ + "static/layer-4-arrow-0bbc78a42a9b06770cb0d6e604c7e006.svg";